import { fork } from 'redux-saga/effects';
import table from '@components/form/table/sagas';
import auth from '@components/auth/sagas';
import users from '@components/users/sagas';
import layout from '@components/layout/sagas';
import modals from '@components/layout/modals/sagas';
import socketModal from '@components/layout/socket-modal/sagas';
import categories from '@components/categories/sagas';
import suppliers from '@components/suppliers/sagas';
import characteristicGroups from '@components/characteristic-groups/sagas';
import characteristics from '@components/characteristics/sagas';
import product from '@components/product/sagas';
import orders from '@components/orders/sagas';
import modules from '@components/module-management/sagas';
import turbosms from '@components/modules/turbosms/sagas';
import utm from '@components/marketing-sources-utm/sagas';
import orderStatuses from '@components/order-statuses/sagas';
import deletedOrders from '@components/deleted-orders/sagas';
import invoice from '@components/invoice/sagas';
import userTasks from '@components/user-tasks/sagas'
import scansheets from '@components/scansheets/sagas'
import rozetka from '@components/modules/rozetka/sagas'
import warehouse from '@components/modules/warehouse/sagas';
import promUa from '@components/modules/prom-ua/sagas'
import nextel from '@components/modules/nextel/sagas'
import lpcrm from '@components/modules/lpcrm/sagas'
import beclearcms from '@components/modules/beclearcms/sagas'
import aftership from '@components/modules/aftership/sagas'
import chat from '@components/chat/sagas'
import { takeEvery } from 'redux-saga/effects';
import store from '@components/store/sagas'
import {Layout} from '@components/layout';
import { LOCATION_CHANGE } from 'connected-react-router'

function* rootSaga() {
    yield fork(table);
    yield fork(auth);
    yield fork(users);
    yield fork(layout);
    yield fork(modals);
    yield fork(socketModal);
    yield fork(categories);
    yield fork(suppliers);
    yield fork(characteristicGroups);
    yield fork(characteristics);
    yield fork(product);
    yield fork(orders);
    yield fork(utm);
    yield fork(modules);
    yield fork(orderStatuses);
    yield fork(invoice);
    yield fork(deletedOrders);
    yield fork(userTasks);
    yield fork(scansheets);
    yield fork(chat);

    // Modules
    yield fork(turbosms);
    yield fork(rozetka);
    yield fork(warehouse);
    yield fork(promUa);
    yield fork(nextel);
    yield fork(lpcrm);
    yield fork(beclearcms);
    yield fork(aftership);
    yield fork(store);

    yield takeEvery([
        LOCATION_CHANGE,
    ], (Layout.actions.openPreloaderSaga));
}

export default rootSaga;
